import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const PageContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 32px;
  text-align: left;
  font-size: 14px;
  color: rgba(46, 47, 51, 0.88);
  font-family: 'Pretendard JP', sans-serif;

  @media (max-width: 480px) {
    gap: 24px;
  }
`;

export const PageHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PageTitle = styled.h1`
  position: relative;
  font-size: 28px;
  letter-spacing: -0.02em;
  line-height: 135.8%;
  color: #171719;
  font-weight: 700;
  margin: 0;
`;

export const PageContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Section = styled.section`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const SectionHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const SectionTitle = styled.h3`
  position: relative;
  letter-spacing: 0.01em;
  line-height: 142.9%;
  font-weight: 600;
  margin: 0;
  font-size: 14px;
  color: rgba(46, 47, 51, 0.88);
`;

export const BannerContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const DragHandle = styled.div`
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: grab;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  opacity: 0.5;

  &:hover {
    background-color: rgba(112, 115, 124, 0.1);
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const BannerImage = styled.div`
  width: 336px;
  height: 116px;
  flex: 0 0 336px;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const Favicon = styled.div`
  width: 116px;
  height: 116px;
`;

export const BannerForm = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  font-size: 16px;
  color: rgba(55, 56, 60, 0.28);
  width: 100%;
  min-width: 0;
`;

export const TitleRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const TitleInput = styled.div`
  flex: 1;
  min-width: 0;
  width: 100% !important;

  .input {
    width: 100% !important;
  }
`;

export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  padding: 8px 12px;
  background-color: white;
  width: 140px;
  min-width: 140px;
  flex-shrink: 0;
`;

export const ColorPicker = styled.input`
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: none;
  outline: none;
  flex-shrink: 0;
`;

export const ColorTextInput = styled.input`
  border: none;
  outline: none;
  background: none;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #448181 !important;
  letter-spacing: 0.01em;
  width: 90px;
  text-transform: uppercase;

  &::placeholder {
    color: rgba(68, 129, 129, 0.5) !important;
  }
`;

export const CaptionRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CaptionInput = styled.div`
  flex: 1;
  min-width: 0;
  width: 100% !important;

  .input {
    width: 100% !important;
  }
`;

export const ImageUploadWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
  transition: border-color 0.2s ease;
  z-index: 10;

  &:hover {
    border-color: #448181;
  }

  &.bannerImage {
    width: 336px;
    height: 116px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    &.bannerImage {
      width: 100%;
      height: 180px;
    }
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  z-index: 11;
  pointer-events: auto;
`;

export const UploadIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  z-index: 12;
  pointer-events: none;
`;

export const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  pointer-events: none;
`;

export const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex: 1;

  .input {
    width: 100% !important;
    border-radius: 12px;
    border: 1px solid rgba(112, 115, 124, 0.16);
    background-color: white;
    padding: 12px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: 'Pretendard JP', sans-serif;
    letter-spacing: 0.01em;
    line-height: 150%;
    color: rgba(55, 56, 60, 0.88);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      outline: none;
      border-color: #448181;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03), 0 0 0 3px rgba(68, 129, 129, 0.1);
    }

    &::placeholder {
      color: rgba(55, 56, 60, 0.28);
    }
  }
`;

interface ButtonWrapperProps {
  $variant?: 'outlined' | 'primary' | 'text';
  $disabled?: boolean;
}

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 150%;
  transition: all 0.2s ease;
  border: none;
  background: none;
  position: relative;
  overflow: hidden;

  ${({ $variant }) =>
    $variant === 'outlined' &&
    css`
      border: 1px solid rgba(112, 115, 124, 0.16);
      color: rgba(46, 47, 51, 0.88);
      background-color: white;

      &:hover {
        border-color: #448181;
        color: #448181;
      }
    `}

  ${({ $variant }) =>
    $variant === 'primary' &&
    css`
      background-color: #448181;
      color: white;
      padding: 12px 28px;

      &:hover {
        background-color: #3a6f6f;
      }
    `}

  ${({ $variant }) =>
    $variant === 'text' &&
    css`
      color: rgba(55, 56, 60, 0.61);
      padding: 4px 16px;

      &:hover {
        background-color: rgba(112, 115, 124, 0.05);
      }
    `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        border-color: rgba(112, 115, 124, 0.16);
        color: rgba(46, 47, 51, 0.88);
      }
    `}
`;

export const CategorySection = styled(Section)`
  display: none;
`;

export const TableContainer = styled.div`
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid #e1e2e4;
  overflow-x: auto;
  background-color: white;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead {
    background-color: rgba(112, 115, 124, 0.05);
    border-bottom: 1px solid rgba(112, 115, 124, 0.16);
  }

  thead th {
    padding: 6px 20px;
    text-align: left;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 138.5%;
    color: rgba(46, 47, 51, 0.88);
  }

  tbody td {
    padding: 16px 20px;
    border-bottom: 1px solid rgba(112, 115, 124, 0.16);
    font-size: 16px;
    color: #171719;
    letter-spacing: 0.01em;
    line-height: 150%;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const TableButton = styled.button`
  border-radius: 8px;
  padding: 7px 8px;
  font-size: 12px;
  letter-spacing: 0.03em;
  line-height: 133.4%;
  font-weight: 500;
  margin-right: 8px;
`;

export const TableButtonDelete = styled(TableButton)`
  color: #e52222;
  border-color: rgba(229, 34, 34, 0.3);
`;

export const CurationContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
`;

export const CurationForm = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const DescriptionInput = styled.div`
  flex: 1;
  font-size: 16px;
`;

export const CurationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const CardGrid = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const Card = styled.div`
  width: calc(25% - 12px);
  height: 175px;
  flex-shrink: 0;

  ${ImageUploadWrapper} {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: calc(50% - 8px);
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const LectureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const LectureCard = styled.div`
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
  transition: all 0.2s ease;

  &:hover {
    border-color: #448181;
    box-shadow: 0 4px 12px rgba(68, 129, 129, 0.15);
  }
`;

export const LectureCardImage = styled.div`
  width: 100%;
  height: 140px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(112, 115, 124, 0.05);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LectureCardContent = styled.div`
  padding: 12px;
`;

export const LectureTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #171719;
  margin: 0 0 4px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LecturerName = styled.p`
  font-size: 12px;
  color: rgba(46, 47, 51, 0.6);
  margin: 0;
  line-height: 1.3;
`;

export const RemoveLectureButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #448181;
  background-color: rgba(255, 255, 255, 0.9);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0;

  ${LectureCard}:hover & {
    opacity: 1;
  }

  &:hover {
    background-color: #e52222;
    transform: scale(1.1);
  }
`;

interface AddLectureCardProps {
  $disabled?: boolean;
}

export const AddLectureCard = styled.div<AddLectureCardProps>`
  border: 2px dashed rgba(112, 115, 124, 0.3);
  border-radius: 12px;
  background-color: rgba(112, 115, 124, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 200px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(112, 115, 124, 0.7);

  &:hover {
    border-color: #448181;
    background-color: rgba(68, 129, 129, 0.05);
    color: #448181;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      border-color: rgba(112, 115, 124, 0.2);
      background-color: rgba(112, 115, 124, 0.05);
      color: rgba(112, 115, 124, 0.5);
      cursor: not-allowed;
      opacity: 0.6;

      &:hover {
        border-color: rgba(112, 115, 124, 0.2);
        background-color: rgba(112, 115, 124, 0.05);
        color: rgba(112, 115, 124, 0.5);
        transform: none;
      }

      span {
        color: rgba(112, 115, 124, 0.5);
      }
    `}
`;

export const NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(112, 115, 124, 0.6);
  background-color: rgba(112, 115, 124, 0.05);
`;

export const LectureModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  max-width: 800px;
  max-height: 80vh;
  width: 90%;
  overflow: hidden;
  z-index: 1001;

  @media (max-width: 768px) {
    width: 95%;
    max-height: 90vh;
  }

  @media (max-width: 480px) {
    width: 98%;
    max-height: 95vh;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #171719;
  }

  button {
    width: 32px;
    height: 32px;
    border: none;
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(112, 115, 124, 0.7);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(112, 115, 124, 0.1);
      color: #171719;
    }
  }
`;

export const ModalBody = styled.div`
  max-height: calc(80vh - 80px);
  overflow-y: auto;
  padding: 0;
`;

export const LectureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

interface LectureListItemProps {
  $alreadyAdded?: boolean;
}

export const LectureListItem = styled.div<LectureListItemProps>`
  display: flex;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.08);
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background-color: rgba(68, 129, 129, 0.05);
  }

  &:last-child {
    border-bottom: none;
  }

  ${({ $alreadyAdded }) =>
    $alreadyAdded &&
    css`
      opacity: 0.6;
      background-color: #f8f9fa;
      border-left: 4px solid #28a745;
      cursor: not-allowed;

      &:hover {
        background-color: #f8f9fa;
        transform: none;
      }
    `}

  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const LectureListImage = styled.div`
  width: 80px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: rgba(112, 115, 124, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: 120px;
  }
`;

export const LectureListContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #171719;
    line-height: 1.4;
  }

  p {
    margin: 0;
    font-size: 12px;
    color: rgba(46, 47, 51, 0.6);
    line-height: 1.3;
  }
`;

export const LectureTags = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
`;

export const Tag = styled.span`
  background-color: rgba(68, 129, 129, 0.1);
  color: #448181;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.2;
`;

export const SaveIndividualButton = styled.div`
  margin-right: 8px;
  min-width: 120px;
  font-size: 14px;
  padding: 10px 16px;
`;

export const ActionButton = styled.div`
  transition: all 0.2s ease;
`;

export const SaveSection = styled.section`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  text-align: center;
  font-size: 16px;
  color: rgba(55, 56, 60, 0.61);
`;

export const SaveActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const TempSaveButton = styled.div`
  display: none;
`;

export const SaveButton = styled.div`
  width: 160px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const SectionActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;

export const LoadingMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: rgba(68, 129, 129, 0.8);
  font-weight: 500;
  background-color: rgba(68, 129, 129, 0.05);
  border-radius: 8px;
  margin: 8px 0;
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background-color: rgba(229, 34, 34, 0.05);
  border: 1px solid rgba(229, 34, 34, 0.2);
  border-radius: 8px;
  color: #e52222;
  font-weight: 500;
  font-size: 14px;
  margin: 8px 0;
`;

export const AddedIndicator = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #28a745;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  z-index: 1;
`;

export const LoadingIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: rgba(68, 129, 129, 0.8);
  font-size: 14px;
  font-weight: 500;
`;

export const Spinner = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid rgba(68, 129, 129, 0.2);
  border-top: 2px solid #448181;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 8px;
`;

export const NoMoreData = styled.div`
  text-align: center;
  padding: 20px;
  color: rgba(46, 47, 51, 0.6);
  font-size: 14px;
  font-weight: 500;
  background-color: rgba(68, 129, 129, 0.05);
  border-radius: 8px;
  margin: 8px 0;
`;

export const RetryButton = styled.button`
  background-color: #448181;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #3a6b6b;
  }

  &:active {
    background-color: #2f5555;
  }
`;

export const SectionsInfo = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(112, 115, 124, 0.16);
`;

export const SectionsTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #171719;
  margin: 0 0 16px 0;
  letter-spacing: 0.01em;
  line-height: 142.9%;
`;

export const SectionCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionCard = styled.div`
  background: white;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  padding: 20px;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(68, 129, 129, 0.3);
  }
`;

export const SectionCardHeader = styled.div`
  margin-bottom: 12px;
`;

export const SectionCardTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #171719;
  margin: 0;
  letter-spacing: 0.01em;
  line-height: 150%;
`;

export const SectionCardText = styled.div`
  margin-bottom: 16px;

  p {
    font-size: 14px;
    color: rgba(46, 47, 51, 0.88);
    line-height: 150%;
    margin: 0;
    letter-spacing: 0.01em;
  }
`;

export const RelatedPersons = styled.div`
  border-top: 1px solid rgba(112, 115, 124, 0.12);
  padding-top: 16px;
`;

export const RelatedPersonsTitle = styled.h4`
  font-size: 13px;
  font-weight: 600;
  color: rgba(46, 47, 51, 0.88);
  margin: 0 0 12px 0;
  letter-spacing: 0.02em;
  line-height: 150%;
`;

export const PersonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PersonCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background: rgba(68, 129, 129, 0.05);
  border-radius: 8px;
`;

export const PersonInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  strong {
    font-size: 14px;
    font-weight: 600;
    color: #171719;
    line-height: 150%;
  }
`;

export const Department = styled.span`
  font-size: 12px;
  color: rgba(46, 47, 51, 0.6);
  line-height: 150%;
`;

export const Tags = styled.span`
  font-size: 11px;
  color: rgba(68, 129, 129, 0.8);
  line-height: 150%;
`;

export const PersonImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const SectionInfoContent = styled.div`
  padding: 20px;
  background: rgba(68, 129, 129, 0.05);
  border-radius: 8px;
  text-align: center;

  p {
    font-size: 14px;
    color: rgba(46, 47, 51, 0.6);
    line-height: 150%;
    margin: 0 0 8px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const PopupPreview = styled.img`
  width: 120px;
  aspect-ratio: 720 / 1022;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
`;

export const PopupImageRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const PopupHint = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: 400;
  color: rgba(55, 56, 60, 0.61);
  line-height: 1.385;
`;

export const PopupUploadButton = styled.button`
  padding: 12px 28px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  background: #fff;
  color: #448181;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.2s;
  &:hover:not(:disabled) { border-color: #448181; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const PopupTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PopupUrlInput = styled.input`
  flex: 1;
  padding: 12px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
  &:focus { border-color: #448181; }
  &::placeholder { color: rgba(55, 56, 60, 0.28); }
`;

export const PopupDeleteButton = styled.button`
  padding: 12px 28px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  background: #fff;
  color: #ff4242;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.2s;
  &:hover:not(:disabled) { border-color: #ff4242; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

export const PopupSaveRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
